const EMPTY_NAME_KEY = '\0';

function trimmedDisplayKey<T extends { name?: string | null; legal_entity?: string | null }>(item: T): string {
  const le = (item.legal_entity ?? '').trim();
  if (le) return le;
  const n = (item.name ?? '').trim();
  return n || EMPTY_NAME_KEY;
}

/**
 * Первое вхождение для каждого ключа отображения контрагента (legal_entity ?? name); пустые имена считаются одним ключом.
 * Нужен для компактного режима и комбо, где не видны различия по услуге/цене.
 */
export function uniqueFirstByTrimmedName<T extends { name?: string | null; legal_entity?: string | null }>(items: T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const item of items) {
    const key = trimmedDisplayKey(item);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
}
